import React from 'react';
import { Textarea } from '@/components/ui/textarea';
import { cn } from '@/lib/utils';

interface SpecificationTextPaneProps {
  heading: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder: string;
  error?: string;
}

const SpecificationTextPane: React.FC<SpecificationTextPaneProps> = ({
  heading,
  value,
  onChange,
  placeholder,
  error,
}) => {
  const id = React.useId();
  const errorId = `${id}-error`;

  return (
    <div>
      <p
        id={id}
        className="revy-cjk mb-1 text-sm font-medium leading-[1.5] text-muted-foreground"
      >
        {heading}
      </p>
      <Textarea
        aria-labelledby={id}
        aria-describedby={error ? errorId : undefined}
        aria-invalid={error ? true : undefined}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required
        rows={12}
        className={cn(
          'font-mono text-sm',
          error && 'border-destructive focus-visible:ring-destructive',
        )}
      />
      {error && (
        <p
          id={errorId}
          role="alert"
          className="revy-cjk mt-1.5 text-xs font-medium leading-[1.7] text-destructive"
        >
          {error}
        </p>
      )}
    </div>
  );
};

export default SpecificationTextPane;
